import { pointsExtractConstants } from './points-extract.constants'

const initialState = {
	isExporting: false,
	downloadData: null
}

function pointsExtractReducer(
	state = initialState,
	{ type, payload: downloadData }
) {
	switch (type) {
		case pointsExtractConstants.EXPORT_DATA:
			return {
				...state,
				isExporting: true
			}

		case pointsExtractConstants.DOWNLOAD_DATA:
			return {
				...state,
				isExporting: false,
				downloadData
			}

		default:
			return state
	}
}

export { pointsExtractReducer as Reducer }
